import React, { SVGProps } from "react";

export default function SupList(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2 2.42105C2 2.18851 2.17909 2 2.4 2H18C18 2.46508 17.6418 2.84211 17.2 2.84211H2.4C2.17909 2.84211 2 2.65359 2 2.42105Z" fill="currentColor" />
      <path d="M2 7.47368C2 7.24114 2.17909 7.05263 2.4 7.05263H18C18 7.51771 17.6418 7.89474 17.2 7.89474H2.4C2.17909 7.89474 2 7.70623 2 7.47368Z" fill="currentColor" />
      <path d="M2 12.5263C2 12.2938 2.17909 12.1053 2.4 12.1053H18C18 12.5703 17.6418 12.9474 17.2 12.9474H2.4C2.17909 12.9474 2 12.7589 2 12.5263Z" fill="currentColor" />
      <path d="M2 17.5789C2 17.3464 2.17909 17.1579 2.4 17.1579H18C18 17.623 17.6418 18 17.2 18H2.4C2.17909 18 2 17.8115 2 17.5789Z" fill="currentColor" />
    </svg>
  );
}
